<template>
  <div>
    <apexchart width="100%" type="line" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "NettoProprietario",
  components: {
    VueApexCharts
  },
  props: ['houseId'],
  data() {
    return {
      options: {
        tooltip: {
          marker: {
            show: false,
          },
        },
        markers: {
          colors: ['#E94E1B'],
        },
        chart: {
          type: 'area',
          height: 160,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false
          }
        },
        xaxis: {
          type: 'category',
          tickPlacement: 'on',
        },
        yaxis: {
          show: true,
          min: 0,
          title: {
            text: 'Netto Proprietario (€)',
          },
          forceNiceScale: true,
          labels: {
            formatter: function (value) {
              var m = Number((Math.abs(value) * 100).toPrecision(15));
              var t = Math.round(m) / 100 * Math.sign(value);
              return t + "€";
            }
          },
        },
        stroke: {
          curve: 'smooth',
          colors: ['#29235C'],
        },
        fill: {
          opacity: 1,
        },
      },
      series: [{
        name: 'Netto Proprietario',
        data: []
      }]

    }
  },
  methods: {
    getDatas() {
      axios.get('/api/get-netto-proprietario/' + this.houseId)
          .then(response => {
                this.showChart = true;
                this.series = [{
                  name: "Netto Proprietario",
                  data: response.data.nettoProprietario
                }]
              }
          ).catch((error) => {
        if (error.response) {
          this.showChart = false;
        }
      });
    },
  },
  mounted() {
    this.getDatas()
  }
}
</script>

<style scoped>

</style>